function loadScript() {
	let qnaItems = document.querySelectorAll('.quiz__qna-list-item')

	qnaItems.forEach((item, index) => {
		if (index > 0) {
			qnaItems[0].classList.add('active')
		}
	})

	$(".quiz__qna-list-item").on("click", function () {
		var parent = $(this);
		if (parent.hasClass("active")) {
			parent.removeClass("active");
		} else {
			$(".quiz__qna-list-item").removeClass("active");
			parent.addClass("active");
		}
	});
}
setTimeout(loadScript, 4000)